/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

export type Credential11Proof = Truvity.CredentialProof | Truvity.CredentialProofs;
